import { g as i } from "./_commonjsHelpers-OnjxAlhP.js";
const n = (o) => {
  const { window: t } = i();
  t && (o.getBoundingClientRect().bottom > t.innerHeight && o.scrollIntoView(!1), o.getBoundingClientRect().top < 0 && o.scrollIntoView({ behavior: "smooth", block: "center" }));
};
export {
  n as s
};
